import React, { Component } from "react";
import { Accordion, AccordionItem } from "react-sanfona";

// CSS
import "../../css/accordian.css";

class FaqAccordian extends Component {
	render() {
		const { faq } = this.props;

		return (
			<Accordion allowMultiple={true}>
				{faq.map((item, i) => (
					<AccordionItem key={i} title={item.question} expanded={item === 1}>
						{item.answer}
					</AccordionItem>
				))}
			</Accordion>
		);
	}
}

export default FaqAccordian;



// WEBPACK FOOTER //
// ./src/components/faq/FaqAccordian.js